































import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import DateInput from "../../core/Forms/DateInput.vue";
import { RecurrenceIntervention } from "../../models/RecurrenceIntervention";
import Remplacement = RecurrenceIntervention.Remplacement;
import RecurrenceInterventionSelect from "../../core/Forms/RecurrenceInterventionSelect.vue";

export default {
    name: "RemplacementModalInterventionsEdit",
    components: {
        RecurrenceInterventionSelect,
    },
    props: {
        remplacement: Remplacement,
    },
    data() {
        return {
            selectedIntervention: null,
        };
    },
    methods: {
        deleteIntervention: function (intervention) {
            _.remove(this.remplacement.recurrence_interventions, {
                id: intervention.id,
            });
            this.$forceUpdate();
        },
    },
    watch: {
        selectedIntervention: function () {
            if (this.selectedIntervention && this.selectedIntervention.id) {
                this.remplacement.recurrence_interventions.push(
                    this.selectedIntervention
                );
                this.selectedIntervention = null;
            }
        },
    },
};
